import { createSelector } from "@reduxjs/toolkit";

const emptyObj = {};
const emptyArr = [];

export const selectConfigSlice = (state: any) => state?.config;

// TODO: Remove all get selectors and use select one
export const getCountries = createSelector(
  selectConfigSlice,
  (configState) => configState?.countryMapping
);

export const getAllCountries = createSelector(
  selectConfigSlice,
  (configState) => configState?.countries
);

export const getUsaCountryId = createSelector(
  selectConfigSlice,
  (configState) => configState?.usaCountryId
);

export const getIsConfigLoading = createSelector(
  selectConfigSlice,
  (configState) => configState?.isFetching
);

export const getCurrencies = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencies || emptyArr
);

export const getDefaultCurrencyCode = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencyConversionRates?.base
);

export const getConversionRates = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencyConversionRates?.rates || emptyObj
);

export const getRecipientInvitationCSVTemplate = createSelector(
  selectConfigSlice,
  (configState) => configState?.customizedEmailInviteSampleCsvUrl
);

export const selectCountries = createSelector(
  selectConfigSlice,
  (configState) => configState?.countryMapping
);

export const selectAllCountries = createSelector(
  selectConfigSlice,
  (configState) => configState?.countries
);

export const selectCountryById = createSelector(
  selectAllCountries,
  (_, id) => id,
  (countries, countryId) => countries.find(({ id }) => id === countryId)
);

export const selectUsaCountryId = createSelector(
  selectConfigSlice,
  (configState) => configState?.usaCountryId
);

export const selectActiveProgramDetail = createSelector(
  selectConfigSlice,
  (configState) => configState?.activeProgramDetail
);

export const selectIsConfigLoading = createSelector(
  selectConfigSlice,
  (configState) => configState?.isFetching
);

export const selectCurrencies = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencies || emptyArr
);

export const selectDefaultCurrencyCode = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencyConversionRates?.base
);

export const selectConversionRates = createSelector(
  selectConfigSlice,
  (configState) => configState?.currencyConversionRates?.rates || emptyObj
);

export const selectPointsPerUSD = createSelector(selectConversionRates, (rates) => rates?.stc);

export const selectRecipientInvitationCSVTemplate = createSelector(
  selectConfigSlice,
  (configState) => configState?.customizedEmailInviteSampleCsvUrl
);
